export function getQueryParams(url = window.location.href) {
  // 创建一个空对象来存储参数
  const params = {};

  // 获取 URL 中 ? 后面的部分
  const queryString = url.split("?")[1];

  if (queryString) {
    // 将参数字符串按 & 分割成键值对数组
    const pairs = queryString.split("&");

    // 遍历键值对数组
    pairs.forEach((pair) => {
      const [key, value] = pair.split("="); // 分割键和值
      const decodedKey = decodeURIComponent(key); // 解码键
      const decodedValue = decodeURIComponent(value || ""); // 解码值

      // 如果键已经存在，将其转换为数组
      if (params.hasOwnProperty(decodedKey)) {
        if (Array.isArray(params[decodedKey])) {
          params[decodedKey].push(decodedValue);
        } else {
          params[decodedKey] = [params[decodedKey], decodedValue];
        }
      } else {
        params[decodedKey] = decodedValue;
      }
    });
  }

  return params;
}

export function removeEndingChars(text) {
  const endings = ["市", "区", "县", "市区", "地区", "自治县"];

  // 先检查多字符结尾
  for (const ending of endings) {
    if (ending.length > 1 && text.endsWith(ending)) {
      return text.slice(0, -ending.length);
    }
  }

  // 再检查单字符结尾
  for (const ending of endings) {
    if (ending.length === 1 && text.endsWith(ending)) {
      return text.slice(0, -1);
    }
  }

  return text;
}



/**
 * 提取视频首帧作为封面图（兼容File/URL输入）
 * @param {File|string} source - 视频源（文件对象或URL地址）
 * @param {Object} [options] - 配置选项
 * @param {string} [options.format='image/png'] - 图片格式
 * @param {number} [options.quality=0.92] - 图片质量（0-1）
 * @param {boolean} [options.crossOrigin=true] - 是否处理跨域
 * @param {number} [options.timeout=10000] - 加载超时时间（毫秒）
 * @returns {Promise<string>} - 返回Base64图片数据
 */
export function getVideoFirstFrame(source, options = {}) {
  return new Promise((resolve, reject) => {
    // 参数校验
    if (!(source instanceof File) && typeof source !== 'string') {
      return reject(new TypeError('Invalid source type, expected File or URL string'));
    }

    // 配置合并
    const {
      format = 'image/png',
      quality = 0.92,
      crossOrigin = true,
      timeout = 10000
    } = options;

    // 创建视频元素和清理函数
    const video = document.createElement('video');
    let objectUrl = null;

    // 清理资源
    const cleanup = () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      video.remove();
    };

    // 错误处理
    const handleError = (error) => {
      cleanup();
      reject(error);
    };

    // 超时处理
    const timeoutId = setTimeout(() => {
      handleError(new Error('Video loading timed out'));
    }, timeout);

    // 视频准备就绪后执行
    const handleReady = () => {
      clearTimeout(timeoutId);

      try {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        ctx.drawImage(video, 0, 0);
        const dataUrl = canvas.toDataURL(format, quality);
        cleanup();
        resolve(dataUrl);
      } catch (e) {
        handleError(e);
      }
    };

    // 事件监听
    video.addEventListener('error', (e) =>
      handleError(new Error(`Video error: ${e.target.error?.message || 'Unknown error'}`)));

    video.addEventListener('loadedmetadata', () => {
      video.currentTime = Math.min(0.2, video.duration);
    });

    video.addEventListener('seeked', handleReady);

    // 设置视频源
    if (source instanceof File) {
      objectUrl = URL.createObjectURL(source);
      video.src = objectUrl;
    } else {
      video.src = source;
      if (crossOrigin) video.crossOrigin = 'anonymous';
    }

    // 启动加载
    video.load();
  });
}


/**
 * 判断参数是否为空
 * @param {*} a
 */
export const isEmpty = (a) => {
  if (a === "") return true; //检验空字符串
  if (a === "null") return true; //检验字符串类型的null
  if (a === "undefined") return true; //检验字符串类型的 undefined
  if (!a && a !== 0 && a !== "") return true; //检验 undefined 和 null
  if (Array.prototype.isPrototypeOf(a) && a.length === 0) return true; //检验空数组
  if (Object.prototype.isPrototypeOf(a) && Object.keys(a).length === 0)
    return true; //检验空对象
  return false;
};
